import React from "react";

import Home from "./Components/Home.js";
import SignIn from "./Components/SignIn.js";
import SignUp2 from "./Components/Signup2.js";
import Availableclasses from "./Components/Availableclassesatyourschool.js";

 import Mainmenustudents from "./Components/MainMenustudents.js";


import SignIn2 from "./Components/SignIn2.js";
import Privacypolicy from "./Components/Privacypolicy.js";
import Support from "./Components/Support.js";
import Tools from "./Components/Tools.js";

import About from "./Components/About.js";
import Messages from "./Components/Messages.js";
import Classroom from "./Components/Classroom.js";

import MainMenupage from "./Components/MainMenu.js";
import Students from "./Components/Students.js";
import Passes from "./Components/Passes.js";
import Particles from "./Components/Particles.js";

import Adminhistorical from "./Components/Adminhistorical.js";
import Adminmainmenu from "./Components/Adminmainmenu.js";
import Adminpassespage from "./Components/Adminpassespage.js";
import Adminsearch from "./Components/Adminsearch.js";

import Getstudents from "./Components/Getstudents.js";
import Getclasses from "./Components/Getclasses.js";

import Compress from "./Components/Compress.js";
import Makemp4 from "./Components/Makemp4.js";

import Messagesforsending from "./Components/Messageforsending.js"


import Authie from "./Components/Oauthcallback.js";

import Getyourgcclasses from "./Components/Getyourgcclasses.js";
import Getyourgcstudents from "./Components/Getyourgcstudents.js";
import Getyourgcgrades from "./Components/Getyourgcgrades.js";
import Getyourstudentgradesall from "./Components/Getyourstudentgradesall.js";

import Postgcgrades from "./Components/Postgcgrades.js";

import Poststudentgcgrades from "./Components/Poststudentgcgrades.js";
import Getyourlastten from "./Components/Getyourlastten.js";

import { Route, Routes } from "react-router-dom";

function App() {
  // eslint-disable-line no-unused-vars

  const cardData = [
    {
      name: "HTML",
      title: "Markup Language",
      description:
        "HTML is a markup language that describe the structure of web pages",
    },
    {
      name: "CSS",
      title: "Styling Language",
      description:
        "CSS is a Style sheet language which is used to describe the look and formatting of a document written in markup language.",
    },
    {
      name: "JAVASCRIPT",
      title: "Programming Language",
      description:
        "Javascript is a programming language that adds interactivity to web pages",
    },
    {
      name: "REACT",
      title: "Javascript Library",
      description:
        "React is a JavaScript-based UI development library for building user interfaces based on components.",
    },
  ];
  return (
    <>
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />

           <Route path="/role/:role/Mainmenustudents/id/:id" element={<Mainmenustudents />} />

          {/* These pages are for Browsing Teachers. If not signed in and not a parent. Support is a teacher informmational page which also includes support email for questions and informational videos */}

          <Route path="/Compress" element={<Compress />} />


          <Route path="/oauthcallback" element={<Authie/>} />

          <Route path="role/:role/mainmenu/id/:id/gcclasses" element={<Getyourgcclasses/>} />

          <Route path="role/:role/mainmenu/id/:id/gcgrades" element={<Getyourgcgrades/>} />

           <Route path="gcgradesone" element={<Getyourstudentgradesall/>} />

            <Route path="role/:role/mainmenu/id/:id/:courseid/:gradetopost/:listofstudents/postgcgrades" element={<Postgcgrades/>} />


                  <Route path="role/:role/mainmenu/id/:id/:courseid/:gradetopost/postgcgrades" element={<Poststudentgcgrades/>} />

          <Route path="role/:role/mainmenu/id/:id/gcstudents" element={<Getyourgcstudents/>} />

          <Route path="/Messagesforsending/role/:role/mainmenu/id/:id" element={<Messagesforsending/>} />


          <Route path="role/:role/mainmenu/id/:id/gcassignments" element={<Getyourlastten/>} />

          <Route path="/Support" element={<Support />} />

            <Route path="/SignIn" element={<SignIn />} />
          <Route path="/SignIn2" element={<SignIn2 />} />
          <Route path="/Signup2" element={<SignUp2 />} />

  <Route path="/role/Student/id/:id/Availableclasses" element={<Availableclasses />} />

   <Route path="/role/:role/Mainmenustudents" element={<Mainmenustudents />} />

          <Route path="/Privacypolicy" element={<Privacypolicy/>}/>

          <Route path="role/Student/Mainmenustudents/id/:id/upcomingbirthday" element={<Particles />} />

          <Route path="/Tools" element={<Tools />} />

          <Route path="/Makemp4" element={<Makemp4 />} />

          <Route path="/Getclasses" element={<Getclasses />} />
          <Route path="/Getstudents" element={<Getstudents />} />

          {/* When an Admin is signed in these are the pages that show up}. . .*/}

          <Route
            path="role/:role/mainmenupage/id/:id"
            element={<Adminmainmenu />}
          />


          <Route
            path="role/:role/passes/id/:id"
            element={<Adminpassespage />}
          />

          <Route path="role/:role/search/id/:id" element={<Adminsearch />} />

          <Route
            path="role/:role/historical/id/:id"
            element={<Adminhistorical />}
          />

          <Route path="role/:role/mainmenu/id/:id" element={<MainMenupage />} />

          <Route
            path="role/:role/getclasses/id/:id/Getyourgcclasses/:Getyourgcclasses"
            element={<Getclasses />}
          />

          {/* <Route path="/App2" element={<Dataa data={cardData}) /> 




                    {/* Parent pages - Messages is a "subscribe options management" page. About is a page about the teacher and class for the Parent to see --- Classroom information should go in About. Classroom is all information about the student's progress in Google Classroom. */}

          {/* When a teacher is signed in these are the pages that show up}. . . MainMenu page is editable and allows the teacher to see what it looks like*/}

          {/* PARENT PAGES  to see all 3
                    
                    Put:
                    
                    http://localhost:3000/studentid/theid/classid/theclassid/language/en" 
                    
                    OR 
                    
                    http://localhost:3000/Messages/studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/About/studentid/theid/classid/theclassid/language/en

                    OR
                    
                    http://localhost:3000/Classroom/studentid/theid/classid/theclassid/language/en
                    
                    " into search bar to get Parent Pages */}

                    {/* These are the roouts foor the third page! */}

          <Route
            path="/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/Messages/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/About/studentid/:studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />
          <Route
            path="/Classroom/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Classroom data={cardData} />}
          />

          {/* PARENT PAGES  to see only 2
                    
                    Put:
                    
                    http://localhost:3000/only2studentid/theid/classid/theclassid/language/en
                    
                    OR 
                    
                    http://localhost:3000/Messages/only2studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/About/only2studentid/theid/classid/theclassid/language/en

                    " into search bar to get Parent Pages */}

          <Route
            path="/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/Messages/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/About/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />

          {/* Teacher View Pages */}

          {/* PARENT PAGES  to see all 3
                    
                    Put:
                    
                    http://localhost:3000/view/id/teaacherid/studentid/theid/classid/theclassid/language/en" 
                    
                    OR 
                    
                    http://localhost:3000/view/id/teaacherid/Messages/studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/view/id/teaacherid/About/studentid/theid/classid/theclassid/language/en

                    OR
                    
                    http://localhost:3000/view/id/teaacherid/Classroom/studentid/theid/classid/theclassid/language/en
                    
                    " into search bar to get Parent Pages */}




          <Route
            path="/view/:role/id/:id/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/view/:role/id/:id/Messages/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/view/:role/id/:id/About/studentid/:studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />
          <Route
            path="/view/:role/id/:id/Classroom/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Classroom data={cardData} />}
          />

          {/* PARENT PAGES  to see only 2
                    
                    Put:
                    
                    http://localhost:3000/view/id/teaacherid/only2studentid/theid/classid/theclassid/language/en
                    
                    OR 
                    
                    http://localhost:3000/view/id/teaacherid/Messages/only2studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/view/id/teaacherid/About/only2studentid/theid/classid/theclassid/language/en

                    " into search bar to get Parent Pages */}

          <Route
            path="/view/:role/id/:id/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/view/:role/id/:id/Messages/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/view/:role/id/:id/About/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />

          {/* Teacher Edit Pages */}

          {/* PARENT PAGES  to see all 3
                    
                    Put:
                    
                    http://localhost:3000/edit/id/teaacherid/studentid/theid/classid/theclassid/language/en" 
                    
                    OR 
                    
                    http://localhost:3000/edit/id/teaacherid/Messages/studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/edit/id/teaacherid/About/studentid/theid/classid/theclassid/language/en

                    OR
                    
                    http://localhost:3000/edit/id/teaacherid/Classroom/studentid/theid/classid/theclassid/language/en
                    
                    " into search bar to get Parent Pages */}

          <Route
            path="/edit/:role/id/:id/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/edit/:role/id/:id/Messages/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/edit/:role/id/:id/About/studentid/:studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />
          <Route
            path="/edit/:role/id/:id/Classroom/studentid/:studentid/:classid/id/:id/language/:language"
            element={<Classroom data={cardData} />}
          />

          {/* PARENT PAGES  to see only 2
                    
                    Put:
                    
                    http://localhost:3000/edit/id/teaacherid/only2studentid/theid/classid/theclassid/language/en
                    
                    OR 
                    
                    http://localhost:3000/edit/id/teaacherid/Messages/only2studentid/theid/classid/theclassid/language/en 
                    
                    OR 
                    
                    http://localhost:3000/edit/id/teaacherid/About/only2studentid/theid/classid/theclassid/language/en

                    " into search bar to get Parent Pages */}

          <Route
            path="/edit/:role/id/:id/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Home data={cardData} />}
          />
          <Route
            path="/edit/:role/:role/id/:id/Messages/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<Messages data={cardData} />}
          />
          <Route
            path="/edit/:role/id/:id/About/only2studentid/:only2studentid/:classid/id/:id/language/:language"
            element={<About data={cardData} />}
          />

          {/* TEACHER SIGNED IN PAGES 
                    
                    Put:
                    
                    http://localhost:3000/id/theid" 
                    
                    OR 
                    
                   http://localhost:3000/MainMenupage/id/theid
                    
                    OR 
                    
                    http://localhost:3000/Students/id/theid/classidd/theclassid

                    OR
                    
                    http://localhost:3000/Passes/id/theid/classidd/theclassid
                    
                    " into search bar to get Teacher Signed In Pages */}
        </Routes>
      </div>

    </>
  );
}

export default App;